import { Columns, Form } from "react-bulma-components";

const { Radio, Checkbox } = Form;

export function RadioColumns({
  name,
  value,
  optionValue,
  onChange,
  children,
  disabled,
}) {
  return (
    <Columns
      gap={1}
      multiline={false}
      className="option-columns"
      breakpoint="mobile"
    >
      <Columns.Column narrow>
        <Radio
          name={name}
          value={optionValue}
          checked={value === optionValue}
          onChange={(e) => onChange(optionValue)}
          disabled={disabled}
        ></Radio>
      </Columns.Column>
      <Columns.Column
        disabled={disabled}
        className="is-clickable"
        onClick={disabled ? undefined : (e) => onChange(optionValue)}
      >
        {children}
      </Columns.Column>
    </Columns>
  );
}

export function CheckboxColumns({ onChange, value, children }) {
  return (
    <Columns
      gap={0}
      multiline={false}
      className="option-columns"
      breakpoint="mobile"
    >
      <Columns.Column narrow>
        <Checkbox
          checked={!!value}
          onChange={(e) => onChange(!!e.target.checked)}
        ></Checkbox>
      </Columns.Column>
      <Columns.Column
        className="is-clickable"
        onClick={(e) => onChange(!value)}
      >
        {children}
      </Columns.Column>
    </Columns>
  );
}
